import { queryOptions } from '@tanstack/react-query';
import { getApartment, listApartments } from '@/api/generated/sdk.gen';
import type { Apartment } from '@/api/generated/types.gen';

export type { Apartment };

export const apartmentsQuery = queryOptions({
  queryKey: ['apartments'],
  queryFn: async ({ signal }) => {
    const res = await listApartments({ throwOnError: true, signal });
    return res.data.items;
  },
  retry: (failureCount, err) => {
    // SDK throws raw Problem JSON on non-2xx; read status off the plain object.
    const status = (err as { status?: number })?.status;
    return status !== 401 && failureCount < 1;
  },
  staleTime: 60_000,
});

export const apartmentQuery = (id: string) =>
  queryOptions({
    queryKey: ['apartments', id],
    queryFn: async ({ signal }) => {
      const res = await getApartment({ throwOnError: true, signal, path: { id } });
      return res.data;
    },
    retry: (failureCount, err) => {
      const status = (err as { status?: number })?.status;
      // 401 / 404 won't fix themselves — render the error state instead.
      return status !== 401 && status !== 404 && failureCount < 1;
    },
    staleTime: 30_000,
  });
